import { callAPI } from "../../lib/common";
export class CheckoutApiClient {
    create() {
        return callAPI("/api/webshop/checkout", "POST");
    }
    createPrepaid(webRegSession) {
        // Replaced direct fetch with callAPI for consistency
        return callAPI("/api/webshop/preorder/checkout", "POST", {
            webRegSession,
        });
    }
    getPaymentOptionsByDeliveryOptionUuid(checkoutUuid, deliveryOptionUuid) {
        return callAPI(`/api/webshop/checkout/${checkoutUuid}/delivery-options/${deliveryOptionUuid}/payment-options`, "GET");
    }
    setPaymentOptionUuid(checkoutUuid, deliveryOptionUuid, paymentOptionUuid) {
        return callAPI(`/api/webshop/checkout/${checkoutUuid}/delivery-options/${deliveryOptionUuid}/payment-options/${paymentOptionUuid}`, "GET");
    }
    useVoucherCode(checkoutUuid, code, deliveryOptionUuid) {
        return callAPI(`/api/webshop/checkout/${checkoutUuid}/verify-rebate-code`, "POST", { code, deliveryOptionUuid });
    }
    buyDigitalSets(checkoutUuid, subjects) {
        return callAPI(`/api/webshop/checkout/${checkoutUuid}/digital-sets`, "POST", { subjects });
    }
    buyCatalogues(checkoutUuid, catalogues) {
        return callAPI(`/api/webshop/checkout/${checkoutUuid}/catalogues`, "POST", { catalogues });
    }
    createTransaction(checkoutUuid, requestData) {
        return callAPI(`/api/webshop/checkout/${checkoutUuid}/transaction`, "POST", requestData);
    }
    autocompleteAddress(query) {
        return callAPI("/api/webshop/postal-address-service/autocomplete?q=" +
            encodeURIComponent(query), "GET");
    }
    resolveAddressById(id) {
        return callAPI("/api/webshop/postal-address-service/resolve-address-by-id/" +
            encodeURIComponent(id), "GET");
    }
}
